import { get } from './fetch';
import config, { endpoints } from '../configShared';

const systemLoginCall = () => {
  return get([config.fetchOptions.url, endpoints.systemLogin].join('/'));
};

export default systemLoginCall;
